const isSurveyShortcut = (event) =>
  event?.code === "ArrowLeft" ||
  event?.key === "ArrowLeft" ||
  event?.code === "ArrowRight" ||
  event?.key === "ArrowRight" ||
  event?.code === "Space" ||
  event?.key === " " ||
  event?.code === "KeyT" ||
  event?.key === "t" ||
  event?.key === "T" ||
  event?.code === "KeyR" ||
  event?.key === "r" ||
  event?.key === "R";

/**
 * Keep native controls and form elements usable, while allowing the survey's
 * documented shortcuts to work after the first-play overlay focuses a video.
 */
const shouldIgnoreSurveyShortcut = (event) => {
  const target = event?.target;

  if (event?.metaKey || event?.ctrlKey || event?.altKey || event?.shiftKey) {
    return true;
  }
  if (target?.isContentEditable) return true;
  if (target?.closest?.("button, a, input, textarea, select")) return true;

  return !isSurveyShortcut(event);
};

export { shouldIgnoreSurveyShortcut };
